import {ApiResource} from 'common/util/model-resource/api-resource';

import {
  deleteLookupTableDefinitions,
  getById,
  LookupTableDefinition,
  lookupTablesClient,
  updateLookupTableDefinition,
} from '../queries/app-api/lookup-tables-client';

export type {LookupTableDefinition};

// TODO - revisit null casting
export class LookupTablesResource extends ApiResource<LookupTableDefinition> {
  apiClient = lookupTablesClient;

  getOne(id: string) {
    if (this.models?.has(id)) {
      return this.models.get(id)!;
    }

    if (this.fetchesInProgress.has(id)) {
      return this.loadingModel();
    }

    // @ts-ignore
    this.fetchesInProgress.set(id, {});
    getById(id)
      .then((result: LookupTableDefinition) => {
        this.update({[id]: result}, {partialUpdate: false});
      })
      .finally(() => {
        this.fetchesInProgress.delete(id);
      });

    return this.loadingModel();
  }

  async patch(id: string, propsToUpdate: Partial<LookupTableDefinition>) {
    // optimistic update
    const copy = this.getOne(id).value;
    this.update({[id]: propsToUpdate});
    try {
      await updateLookupTableDefinition(id, propsToUpdate);
    } catch (error) {
      this.update({[id]: copy}, {partialUpdate: false});
      throw error;
    }
  }

  async delete(id: string) {
    // optimistic update
    super.delete(id);
    try {
      await deleteLookupTableDefinitions([id]);
    } catch (error) {
      const copy = this.getOne(id).value;
      super.update({[id]: copy}, {partialUpdate: false});
      throw error;
    }
  }

  async bulkDelete(ids: string[]) {
    // optimistic update
    const copy = this.getAll();
    ids.forEach((id) => {
      super.delete(id);
    });

    try {
      await deleteLookupTableDefinitions(ids);
    } catch (error) {
      // if status is not success, revert the update
      ids.forEach((id) => {
        copy?.get(id)?.value && this.update({[id]: copy.get(id)!.value!}, {partialUpdate: false});
      });

      throw error;
    }
  }
}
